import $ from 'jquery'
$(function(){
    //tel非表示
    var ua = navigator.userAgent;
    if(ua.indexOf('iPhone') < 0 && ua.indexOf('Android') < 0){
        $('.telhref span').each(function(){
            $(this).unwrap();
        });
    }

    //ページTOPへ
    var topBtn = $('#side-nav');
    topBtn.hide();
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });
    topBtn.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
        return false;
    });

    // falg変数のデフォルト値として「up」を指定
    var flag = "up";

    // scrollイベントを取得した際の処理を定義
    $(window).on("scroll", function () {
        // scrollTop()が「0」より大きい場合に表示する
        if ($(this).scrollTop() > 500) {
            // flag変数が「up」だった場合の処理
            if (flag === "up") {
                // ヘッダーバーに対して、stop()メソッドを実行してから、
                // animate()メソッドを実行
                $("#formup").stop().animate({
                    // topの位置を「-56px」から「0」になるまでアニメーション
                    bottom: 0
                    // アニメーション時間を「500ms」に設定
                }, 500)
                // flag変数の値を「down」に変更
                flag = "down";
            }
            // scrollTop()が「9000」より大きい場合に非表示にする
            if ($(this).scrollTop() > 55500) {
                // flag変数が「up」だった場合の処理
                if (flag === "down") {
                    // ヘッダーバーに対して、stop()メソッドを実行してから、
                    // animate()メソッドを実行
                    $("#formup").stop().animate({
                        // topの位置を「-56px」から「0」になるまでアニメーション
                        bottom: "-163px"
                        // アニメーション時間を「500ms」に設定
                    }, 500)
                    // flag変数の値を「down」に変更
                    flag = "up";
                }
            }
            // scrollTop()が「0」の場合に非表示にする
        } else {
            // flag変数が「down」だった場合の処理
            if (flag === "down") {
                // ヘッダーバーに対して、stop()メソッドを実行してから、
                // animate()メソッドを実行
                $("#formup").stop().animate({
                    // topの位置を「0」から「-56px」になるまでアニメーション
                    bottom: "-163px"
                    // アニメーション時間を「500ms」に設定
                }, 500);
                // flag変数の値を「up」に変更
                flag = "up";
            }
        }
    });
});